import { useState } from 'react';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "散布代行の料金はどのくらいですか？",
      answer: "料金は拠点や作物、圃場の条件により異なります。一般的には1haあたり3,000円〜5,000円程度ですが、詳細はお見積りをご依頼ください。1ha未満の場合は1ha分の料金となる場合がございます。"
    },
    {
      question: "農薬は用意してもらえますか？",
      answer: "はい、農薬のご用意も可能です。お客様がお持ちの農薬を使用することも可能ですし、当社で適切な農薬を選定・調達することも可能です。事前にご相談ください。"
    },
    {
      question: "どのくらい前に予約が必要ですか？",
      answer: "通常は1週間前までにご予約をお願いしています。ただし、天候や作業スケジュールにより調整が必要な場合があります。急なご依頼にも可能な限り対応いたしますので、まずはご相談ください。"
    },
    {
      question: "雨天時はどうなりますか？",
      answer: "雨天や強風時は安全のため作業を中止いたします。天候による延期の場合、追加料金は発生いたしません。作業可能な日程に調整させていただきます。"
    },
    {
      question: "中山間地域の複雑な圃場でも対応できますか？",
      answer: "はい、中山間地域の複雑な圃場にも対応しています。事前に現地調査を行い、安全に作業できるかを確認いたします。地形や障害物の状況により対応可否を判断いたします。"
    },
    {
      question: "散布後の効果はどの程度期待できますか？",
      answer: "ドローンによる散布は均一で精密な散布が可能で、従来の方法と同等以上の効果が期待できます。風の影響を受けにくく、作物への薬害リスクも低減できます。"
    },
    {
      question: "保険は適用されますか？",
      answer: "当社では農業ドローン保険に加入しており、作業中の事故や機体トラブルに対応しています。万が一の場合も安心してご利用いただけます。"
    },
    {
      question: "対応エリア外でも相談できますか？",
      answer: "対応エリア外でもご相談ください。圃場の規模や条件によっては対応可能な場合があります。まずはお気軽にお問い合わせください。"
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            よくあるご質問
          </h2>
          <div className="w-24 h-1 bg-[#4CAF50] mx-auto mb-6"></div>
          <p className="text-lg text-gray-600">
            散布代行サービスに関するよくあるご質問をまとめました。
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div key={index} className="border border-gray-200 rounded-xl overflow-hidden">
              <button
                className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors cursor-pointer flex items-center justify-between"
                onClick={() => toggleFAQ(index)}
              >
                <span className="font-semibold text-gray-900 pr-4">{faq.question}</span>
                <i className={`ri-arrow-down-s-line text-xl text-gray-500 transition-transform flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`}></i>
              </button>
              {openIndex === index && (
                <div className="px-6 py-4 bg-white border-t border-gray-200">
                  <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-6">
            その他ご不明な点がございましたら、お気軽にお問い合わせください。
          </p>
          <button 
            className="px-8 py-4 bg-[#4CAF50] text-white rounded-lg hover:bg-[#45a049] transition-colors font-semibold text-lg whitespace-nowrap cursor-pointer"
            onClick={() => {
              const contactSection = document.querySelector('[data-contact-section]');
              if (contactSection) {
                contactSection.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            お問い合わせ
          </button>
        </div>
      </div>
    </section>
  );
}